var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Container, Box, makeStyles } from "@material-ui/core";
import D from "../assets/img/bg-auth.svg";
import { useHistory, Link } from "react-router-dom";
import { errorService, FTLDateUtils } from "ftl-dashboards-core";
import { AuthRepository as StaticAuthRepository } from "ftl-auth-module";
import { FTLLogoIcon, FTLTypography, FTLTextField, FTLPasswordField, FTLButton, } from "ftl-dashboards-ui-kit";
export default ({ title, redirectOnAuthUrl, AuthRepository, logo = _jsx(FTLLogoIcon, {}, void 0), }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const history = useHistory();
    const [errorHighlight, setErrorHighlight] = useState(null);
    const handleOnAuth = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        e.preventDefault();
        try {
            setIsLoading(true);
            yield AuthRepository.signIn(email, password);
            history.push(redirectOnAuthUrl);
        }
        catch (error) {
            const details = (_b = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.errors[0]) === null || _b === void 0 ? void 0 : _b.details;
            if (details === "INVALID_EMAIL")
                setErrorHighlight("email");
            else if (details === "INVALID_PASSWORD") {
                setErrorHighlight("password");
            }
            else {
                setErrorHighlight("all");
            }
            errorService.show({
                error,
            });
        }
        finally {
            setIsLoading(false);
        }
    });
    useEffect(() => {
        if (StaticAuthRepository.isAuth)
            history.push(redirectOnAuthUrl);
    }, []);
    const classes = useStyles();
    return (_jsx("div", Object.assign({ style: {
            backgroundImage: `url(${D})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "bottom",
            backgroundSize: "100% auto",
        } }, { children: _jsx(Container, Object.assign({ maxWidth: "md", disableGutters: true, classes: {
                maxWidthXs: classes.maxWidthXs,
            } }, { children: _jsx(Box, Object.assign({ display: "flex", justifyContent: "center" }, { children: _jsxs(Box, Object.assign({ display: "flex", justifyContent: "center", flexDirection: "column", height: "calc(100vh - 40px)", mb: "40px" }, { children: [_jsxs(Box, Object.assign({ margin: "auto auto 0" }, { children: [_jsx(Box, Object.assign({ textAlign: "center" }, { children: logo }), void 0),
                                _jsx(Box, Object.assign({ mt: 6 }, { children: _jsx(FTLTypography, Object.assign({ variant: "h3" }, { children: title }), void 0) }), void 0)] }), void 0),
                        _jsx(Box, Object.assign({ mt: 6 }, { children: _jsxs("form", Object.assign({ noValidate: true, onSubmit: handleOnAuth }, { children: [_jsx(Box, Object.assign({ width: "280px" }, { children: _jsx(FTLTextField, { name: "email", fullWidth: true, label: "Email", autoComplete: "on", value: email, type: "email", onChange: (e) => setEmail(e.target.value), error: errorHighlight === "email" || errorHighlight === "all" }, void 0) }), void 0),
                                    _jsx(Box, Object.assign({ width: "280px", mt: 6 }, { children: _jsx(FTLPasswordField, { fullWidth: true, name: "password", label: "\u041F\u0430\u0440\u043E\u043B\u044C", onChange: (e) => setPassword(e.target.value), error: errorHighlight === "password" || errorHighlight === "all" }, void 0) }), void 0),
                                    _jsx(Box, Object.assign({ mt: 6 }, { children: _jsx(FTLButton, Object.assign({ fullWidth: true, async: isLoading, color: "primary", type: "submit", size: "large" }, { children: "\u0412\u043E\u0439\u0442\u0438" }), void 0) }), void 0)] }), void 0) }), void 0),
                        _jsxs(Box, Object.assign({ mt: 12, marginLeft: "auto", marginRight: "auto", display: "flex" }, { children: [_jsx(Box, { children: _jsx(Link, Object.assign({ to: "/" }, { children: _jsx(FTLTypography, Object.assign({ variant: "lawExplanations", color: "secondary" }, { children: "\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C" }), void 0) }), void 0) }, void 0),
                                _jsx(Box, Object.assign({ ml: 4 }, { children: _jsx(Link, Object.assign({ to: "/" }, { children: _jsx(FTLTypography, Object.assign({ variant: "lawExplanations", color: "secondary" }, { children: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C" }), void 0) }), void 0) }), void 0)] }), void 0),
                        _jsx(Box, Object.assign({ mt: "auto", textAlign: "center" }, { children: _jsx(Link, Object.assign({ to: "/" }, { children: _jsxs(FTLTypography, Object.assign({ variant: "lawExplanations", color: "secondary" }, { children: ["\u00A9", FTLDateUtils.currentYear, " FoodTech Lab"] }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0) }), void 0));
};
const useStyles = makeStyles({
    maxWidthXs: {
        maxWidth: 280,
    },
});
//# sourceMappingURL=FTLAuthPage.js.map